import Vue from "vue"
import Router from "vue-router"
import store from "./store/store"

Vue.use(Router)

let router = new Router({
    mode: `history`,
    routes: [
        {
            path: `/`,
            name: `Preload`,
        },
        {
            path: `/Loginpage`,
            name: `Loginpage`,
            component: () => import(`./views/Loginpage.vue`),
            beforeEnter: beforeEnter,
        },
        {
            path: `/DepublishPage`,
            name: `DepublishPage`,
            component: () => import(`./views/DepublishPage.vue`),
            beforeEnter: beforeEnter,
        },
        {
            path: `/RestartPage`,
            name: `RestartPage`,
            component: () => import(`./views/RestartPage.vue`),
            beforeEnter: beforeEnter,
        },
        {
            path: `/Beginpage`,
            name: `Beginpage`,
            component: () => import(`./views/Beginpage.vue`),
            beforeEnter: beforeEnter,
        },
        {
            path: `/questionnaire`,
            name: `Questionnaire`,
            component: () => import(`./views/Questionnaire.vue`),
            beforeEnter: (to, from, next) => {
                if (from.name === null) store.commit(`changeGlobal`, { variableName: `isRefreshed`, newValue: true })

                next()
            },
        },
        {
            path: `/endpage`,
            name: `Endpage`,
            component: () => import(`./views/Endpage.vue`),
            beforeEnter: beforeEnter,
        },
        {
            path: `/Feedbackpage`,
            name: `Feedbackpage`,
            component: () => import(`./views/Feedbackpage.vue`),
            beforeEnter: (to, from, next) => {
                if (from.name === null && to.path !== from.path) {
                    router.replace(`/${location.search}`)
                    location.reload()
                }

                next()
            },
        },
    ],
})

function beforeEnter(to, from, next) {
    // Within iframes we don't want to do this
    if (store.state.global.isWithinIframe === false) {
        // This is used to properly restart surveyfrontend when the user has refreshed the page
        if (from.name === null && to.path !== from.path) {
            router.replace(`/`)
            location.reload()
        }
    }

    next()
}

export default router
